import { render, staticRenderFns } from "./douBar.vue?vue&type=template&id=2b553f2e&scoped=true&"
import script from "./douBar.vue?vue&type=script&lang=js&"
export * from "./douBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b553f2e",
  null
  
)

export default component.exports